let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("en5b2")).then(() => parcelRequire('kTS7u'));